@if (dataLoaded$ | async) {
  <ion-tabs>
    <ion-tab-bar slot="bottom">
      <ion-tab-button tab="general">
        <ion-icon name="home"></ion-icon>
        General
      </ion-tab-button>
      <ion-tab-button tab="costs">
        <ion-icon name="pricetag"></ion-icon>
        Costs
      </ion-tab-button>
      <ion-tab-button tab="analytics">
        <ion-icon name="bar-chart"></ion-icon>
        Analytics
      </ion-tab-button>
      <ion-tab-button tab="comparables">
        <ion-icon name="search"></ion-icon>
        Comparables
      </ion-tab-button>
    </ion-tab-bar>
  </ion-tabs>
} @else {
  <!-- LOADING INDICATOR -->
  <div class="PropertyDetails__SpinnerWrapper">
    <div class="PropertyDetails__Spinner">
      <ion-spinner></ion-spinner>
    </div>
  </div>
}
